import { Action, createReducer, on } from '@ngrx/store'
import { ExpenseState, initialExpenseState } from '../state/expense.state'
import { CLEAR_EXPENSES, FETCH_EXPENSES_SUCCESS } from '../action/expense.action'
import { FETCH_EXPENSE_REPORT_LIST_SUCCESS } from '../action/expense.action'

export function expenseReducer(state: ExpenseState, action: Action) {
  return _expenseReducer(state, action)
}

const _expenseReducer = createReducer(
  initialExpenseState,
  on(FETCH_EXPENSES_SUCCESS, (state, { expenses }) => {
    return {
      ...state,
      expenses
    }
  }),
  on(FETCH_EXPENSE_REPORT_LIST_SUCCESS, (state, { expenseReportList }) => {
    return {
      ...state,
      expenseReportList
    }
  }),
  on(CLEAR_EXPENSES, (state, {}) => {
    return {
      ...state,
      expenses: null
    }
  })
)
